import React, { useState, useEffect } from 'react';
import { Container, ThisCard, SectionContrato, ThisCardItem } from './styles';

// import IconColor from '~/assets/icones/IconColor.svg';
// import IconColorB from '~/assets/icones/IconColorB.svg';
// import IconCircleRel from '~/assets/icones/IconCircleRel.svg';
// import IconCircleRelB from '~/assets/icones/IconCircleRelB.svg';
import IconProjData from '~/assets/icones/IconProjData.svg';
import IconProjTempo from '~/assets/icones/IconProjTempo.svg';
// import IconProjCoord from '~/assets/icones/IconProjCoord.svg';
// import IconProjEtapa from '~/assets/icones/IconProjEtapa.svg';
import IconProjDataB from '~/assets/icones/IconProjDataB.svg';
import IconProjTempoB from '~/assets/icones/IconProjTempoB.svg';
// import IconProjCoordB from '~/assets/icones/IconProjCoordB.svg';
// import IconProjEtapaB from '~/assets/icones/IconProjEtapaB.svg';
// import IconProjeto from '~/assets/icones/IconProjeto.svg';
import IconCliente from '~/assets/icones/IconCliente.svg';

function CustomBodyContent({ data }) {
  const [tickets, setTicket] = useState([]);
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  useEffect(() => {
    if (data && data?.length) {
      let dados = [];

      for (const item of data) {
        dados.push({ ...item, aberto: false });
      }

      setTicket(dados);
    }
  }, [data]);

  return (
    <Container>
      <SectionContrato>
        <div className="div-icone">
          <img src={IconCliente} alt={'IconCliente'} />
          <h4 className="title">Contratos</h4>
        </div>
        {tickets?.map(thisData => (
          <div className="card" key={thisData?.id}>
            <ThisCard
              onClick={() => {
                let dados = [];
                for (const item of tickets) {
                  if (thisData?.id == item?.id) {
                    dados.push({ ...item, aberto: !item?.aberto });
                  } else {
                    dados.push({ ...item, aberto: item?.aberto });
                  }
                }
                setTicket(dados);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              <div className="top">
                <div className="content-top">
                  <div className="card-top">
                    <p className="titulo">{thisData?.razaoSocial}</p>
                    <p className="analista">{thisData?.email}</p>
                  </div>
                </div>
              </div>
            </ThisCard>

            <div className={thisData?.aberto ? 'item' : ''}>
              {thisData?.aberto &&
                thisData?.contratos?.map(thisContrato => (
                  <ThisCardItem
                    {...{ data: thisContrato, linhaAtiva, setLinhaAtiva }}
                    key={thisContrato?.id}
                    onClick={() => {
                      const allElements = document.querySelectorAll('*');
                      allElements.forEach(el => {
                        if (el.scrollTop > 0) {
                          el.scrollTop = 0;
                        }
                      });

                      window.scrollTo(0, 0);
                    }}
                  >
                    <div className="top">
                      <div className="content-top">
                        <div className="card-top">
                          <p className="titulo">
                            #{thisContrato?.id} - Contrato de {thisContrato?.produto?.titulo} (
                            {thisContrato?.tipoContrato ? 'Suporte' : 'Banco de Horas'})
                          </p>
                          <p className="analista">MoviDesk: {thisContrato?.idMoviDesk}</p>
                        </div>
                      </div>
                    </div>
                    <div className="content-os">
                      <div className="info">
                        <div className="item-info">
                          <img
                            src={localStorage.getItem('tema') == 'E' ? IconProjData : IconProjDataB}
                            alt={'IconProjData'}
                          />
                          <p className="data">
                            {'De: (' +
                              thisContrato?.dataInicio +
                              ') Até (' +
                              thisContrato?.dataVencimento +
                              ')'}
                          </p>
                        </div>
                        <div className="item-info">
                          <img
                            src={
                              localStorage.getItem('tema') == 'E' ? IconProjTempo : IconProjTempoB
                            }
                            alt={'IconProjTempo'}
                          />
                          <p className="data">Total de Horas: {thisContrato?.quantidadeHoras}</p>
                        </div>
                      </div>
                    </div>
                  </ThisCardItem>
                ))}
            </div>
          </div>
        ))}
      </SectionContrato>
    </Container>
  );
}

export default CustomBodyContent;
